import { BlueprintWizard } from './BlueprintWizard';
import { Box, Typography } from '@mui/material';
import { Breadcrumb } from 'components/layout/Breadcrumb';
import { useTranslation } from 'react-i18next';

export default function NewBlueprint() {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb />
      <Typography variant="h4" style={{ margin: 0 }}>
        {t('blueprints:overview.buttons.newBlueprint')}
      </Typography>
      <Box mt={3}>
        <BlueprintWizard />
      </Box>
    </>
  );
}
